// extracted by mini-css-extract-plugin
export var formContainer = "_l1-0";
export var message = "_l1-1";